module.exports = __webpack_public_path__ + "img/logo-with-year.4b5caf27.svg";